import I18n from 'I18n';
export const getTranslatedLanguageName = languageKey => I18n.text(`SharedI18nStrings.languageNames.${languageKey}`);